import * as service from './service'
export default {
  namespace: 'walletAccountRecharge',
  state: {
    rechargeData: {}
  },
  effects: {
    * recharge ({ payload }, { call, put }) {
      const res = yield call(service.recharge, payload)
      yield put({
        type: 'save',
        payload: {
          rechargeData: res.data.data && JSON.parse(res.data.data)
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
